import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 病院管理者一覧
 *
 * 自分が所属しているプライマリ病院の管理者一覧を返す
 */
export class FetchDoctor implements APIRequest<Monitaro.FetchDoctorResponse> {
  response: Monitaro.FetchDoctorResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/doctors`
  }
}

/**
 * 病院間連携の病院管理者一覧
 *
 * 病院間連携している病院管理者ユーザーの一覧を返す
 */
export class FetchDoctorHospital implements APIRequest<Monitaro.FetchDoctorResponse> {
  response: Monitaro.FetchDoctorResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/doctors/hospital`
  }
}

/**
 * 病院管理者データの作成と招待
 *
 * 招待するユーザーのプライマリ病院に対して病院管理者データを作成し招待メールを送信する
 */
export class PostDoctor implements APIRequest<Monitaro.PostDoctorResponse> {
  response: Monitaro.PostDoctorResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: Monitaro.DoctorRequest
  constructor(params: Monitaro.DoctorRequest) {
    this.params = params
    this.path = `/doctors`
  }
}

/**
 * 病院管理者データの取得
 *
 * 自分が所属している病院の病院管理者の詳細を取得する&lt;br&gt;
所属していない病院の病院管理者IDが指定された場合はステータス404
 */
export class GetDoctor implements APIRequest<Monitaro.GetDoctorResponse> {
  response: Monitaro.GetDoctorResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(doctor: string) {
    this.path = `/doctors/${doctor}`
  }
}

/**
 * 病院管理者データの所属病院の更新
 *
 * すでに招待済みの病院管理者を再度招待する
 */
export class PutDoctor implements APIRequest<Monitaro.PutDoctorResponse> {
  response: Monitaro.PutDoctorResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PUT
  params: Monitaro.DoctorRequest
  constructor(doctor: string, params: Monitaro.DoctorRequest) {
    this.params = params
    this.path = `/doctors/${doctor}`
  }
}

/**
 * 病院管理者データの紐づけの解除
 *
 * 自分が所属している病院から指定された病院管理者IDのユーザーを解除する
 */
export class DeleteDoctor implements APIRequest<Monitaro.DeleteDoctorResponse> {
  response: Monitaro.DeleteDoctorResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.DELETE
  constructor(doctor: string) {
    this.path = `/doctors/${doctor}`
  }
}

/**
 * 未登録職員に再度招待メールを送信
 *
 * 自分が所属している病院の未登録職員に再度招待メールを送信する
 */
export class PostDoctorInvitation implements APIRequest<Monitaro.PostDoctorInvitationResponse> {
  response: Monitaro.PostDoctorInvitationResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  constructor(hospital: string) {
    this.path = `/doctors/invitation/${hospital}`
  }
}
